import React from 'react';
import { useIsMobile } from '@guildeducationinc/catalog-tools';
import { Typography } from '@guildeducationinc/recess';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import styles from './ProgramContentItems.module.scss';

interface Props {
	ariaLabel: string;
	children?: React.ReactNode;
	className?: string;
	contentItems: GetMemberProgramQuery['memberProgram']['contentItems'];
	sectionTitle: string;
}

export const ProgramContentItems: React.FC<Props> = ({
	ariaLabel,
	children,
	className,
	contentItems,
	sectionTitle,
}) => {
	const isMobile = useIsMobile();

	return (
		<section aria-label={ariaLabel} className={className}>
			<Typography variant='title3'>{sectionTitle}</Typography>
			{contentItems && (
				<ul className={styles.list} data-testid='program-content-list'>
					{contentItems.length &&
						contentItems.map(item => (
							<li
								className={styles.listItem}
								data-testid='program-content-list-item'
								key={`${item.category}-${item.title}`}
							>
								{item.title && item.title !== ' ' ? (
									<Typography variant={isMobile ? 'body1' : 'body2'}>
										{item.title.trim()}
										{item.body && `: ${item.body}`}
									</Typography>
								) : (
									<Typography variant={isMobile ? 'body1' : 'body2'}>{item.body}</Typography>
								)}
							</li>
						))}
				</ul>
			)}
			{children}
		</section>
	);
};
